module.exports = __webpack_public_path__ + "img/gold-4.c19717fb.png";